/// <reference path="../../global/fn.js" />


;(function ($) {

    $.widget("nsp.breadcrumb", {
        options: {},

        _create: function () {

            if($('html').hasClass("no-touchevents")){
                this._init()
            }

        },

        _init(){
            this.wrap = this.element;
            this.mover = $('ul', this.wrap);
            this.windowW = this._getWindowWidth()

            this._resetPosition()
            this._checkIfActive();


            $(document).on("window-resized", ()=>{
                var newWindowW = this._getWindowWidth()

                if(this.windowW != newWindowW){
                    this.windowW = this._getWindowWidth()
                    this._resetPosition()
                    this._checkIfActive();
                }
                
            });

            this._events();
        },

        _events() {

            var offsetX = 0;
            var isDown = false;
            $('.s-breadcrumb__conts')[0].addEventListener('mousedown', (e) => {
                isDown = true;
                offsetX = this.mover[0].offsetLeft - e.clientX;
                
            }, true);

            document.addEventListener('mouseup', (e) => {
                isDown = false;
            }, true);

            document.addEventListener('mousemove', (e) => {
                //event.preventDefault();
                if (isDown) {
                    var finalX = e.clientX + offsetX
                    this._moveOverlay(finalX)
                }
            }, true);

        },

        _checkIfActive() {
            var moverW = this.mover[0].scrollWidth;
            var parentW = this.mover.parent().outerWidth();

            if (moverW + this.margL > parentW) {
                this.wrap.removeClass('not-active').addClass('movable')
                return true
            } else {
                this.wrap.addClass('not-active').removeClass('movable')
                return false
            }
        },

        _moveOverlay(finalX) {

            if (this._checkIfActive()) {

                finalX = finalX <= 0 ? finalX : 0;
                var moverW = this.mover[0].scrollWidth;
                var parentW = this.mover.parent().outerWidth();
                var minX = - moverW - this.margL - 50 + parentW
                finalX = finalX >= minX ? finalX : minX
                
                this.mover.css('left', `${finalX}px`)
            }

        },

        _getWindowWidth() {
            return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        },

        _resetPosition(){
            this.mover.css('left', 0)
            this.margL = this.mover.offset().left;
        }

    });
})(jQuery);